import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Switch } from "@mui/material";
import clsx from "clsx";
import { ChangeEvent, CSSProperties, ReactElement, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { IColumnDef } from "@ryde/shared";

import { ColumnItem, ColumnItemText } from "./column.draggable.styled";

export const ColumnDraggable = <T extends object>({
  item,
  onVisibilityChange,
}: {
  item: IColumnDef<T, unknown>;
  onVisibilityChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}): ReactElement => {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
    transform,
    transition,
  } = useSortable({
    id: item.id || "unknown_column",
  });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };

  const translatedColumnTitle = useMemo(() => {
    return item.meta?.translationKey
      ? t(item.meta?.translationKey)
      : item.meta?.displayName || item.id;
  }, [item.id, item.meta?.displayName, item.meta?.translationKey, t]);

  return (
    <ColumnItem
      ref={setNodeRef}
      style={style}
      {...attributes}
      $isDragging={isDragging}
      className={clsx({ is_hidden: item.meta?.isHiddenFromView })}
    >
      <SVG_MUI.GripVerticalSVG className="pointer" {...listeners} />

      <ColumnItemText>{translatedColumnTitle}</ColumnItemText>

      <Switch
        className="col_switch"
        id={item.id as string}
        checked={true}
        disabled={item.meta?.orderable === false}
        onChange={onVisibilityChange}
      />
    </ColumnItem>
  );
};
